import EventEmitter from 'eventemitter3';

import type {
  BaseServerDisconnectReasonMessage,
  BaseWebsocketServerErrorMessage,
} from '@genially/p2p-lib';

import type { P2pLogger } from '../../util/logger';

export type TransportEvents<Message> = {
  open: [];

  close: [BaseServerDisconnectReasonMessage | undefined];

  error: [BaseWebsocketServerErrorMessage | undefined];

  message: [Message];
};

export abstract class Transport<Message = any> {
  readonly emitter = new EventEmitter<TransportEvents<Message>>();

  protected abstract logger: P2pLogger;

  abstract get connecting(): boolean;

  abstract get connected(): boolean;

  abstract get readyState(): number;

  abstract send(message: string): void;

  abstract close(): void;
}
